import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import {
    HisSearchResultComponent, HisAuthService, HisUiService, HisNavigationService,
    HisNotificationService, HisConfirmationService
} from 'hisng';

import { CONFIRMATION_PDIALOG_KEY } from 'app/fs/res/common/component/confirmation-dialogs/confirmation-dialog.component';
import { INFORMATION_PDIALOG_KEY } from 'app/fs/res/common/component/confirmation-dialogs/information-dialog.component';
import { PatentService } from 'app/fs/res/patent/service/patent/patent.service';

const SEARCH_CONFIG_FILE = 'fs/res/searchPriorityPatent.xml';

@Component({
    selector: 'res-patent-search-result',
    templateUrl: './patent-search-result.component.html'
})
export class PatentSearchResultComponent implements OnInit {
    @ViewChild(HisSearchResultComponent, { static: true }) searchResultComponent: HisSearchResultComponent;
    public priorityPatentSearchResult = false;
    public showBackButton = false;

    constructor(
        public auth: HisAuthService,
        private route: ActivatedRoute,
        private confirmationService: HisConfirmationService,
        private notificationService: HisNotificationService,
        private hisUiService: HisUiService,
        public navigationService: HisNavigationService,
        private patentService: PatentService) {
    }

    /* Component ngOnInit()
     * used to get parameter of configFile to configure search result page.
     */
    ngOnInit() {
        this.route.queryParams.subscribe( (queryParams: Params) => {
            if (queryParams.configFile === SEARCH_CONFIG_FILE) {
                this.priorityPatentSearchResult = true;
            }
            this.showBackButton = queryParams.showBackButton ? queryParams.showBackButton === 'true' : this.showBackButton;
        });
    }

    /* callback to set last window location href */
    public onBeforeNavigate() {
        this.navigationService.setLastBackUrl( window.location.href );
    }

    /* delete selected patent from database */
    deleteRow(patentRow: any) {
        this.patentService.canDeletePatent(patentRow.get('Patent.id')).subscribe( (canDelete: number) => {
            if (canDelete === 0) {
                this.confirm('fs.res.patent.Patent.failure.delete', patentRow, canDelete);
            } else {
                this.confirm('fs.res.patent.confirmDeletePatent', patentRow, canDelete);
            }
        });
    }

    /**
     * confirmation service to load confirmation-/information dialog
     *
     * @param msg dialog message
     * @param patentRow patent (object) to delete
     * @param canDelete identifier patent can be deleted
     */
    private confirm(msg: string, patentRow: any, canDelete: number) {
        this.confirmationService.confirm({
            key: canDelete === 1 ? CONFIRMATION_PDIALOG_KEY : INFORMATION_PDIALOG_KEY,
            message: this.hisUiService.translate(msg, patentRow.get('Patent.title')),
            accept: () => {
                if (canDelete === 1) {
                    this.patentService.deletePatent(patentRow.get('Patent.id')).subscribe( (deleteSuccess: number) => {
                        if (deleteSuccess === 1) {
                            this.notificationService.deleteSuccessI18nRes();
                            this.searchResultComponent.reloadPageAfterDelete();
                        }
                    });
                }
            }
        });

    }
}
